import { FC, useState, useEffect } from "react";
import { connectMenu } from "react-instantsearch-dom";
import { MenuProvided } from "react-instantsearch-core";
import { Trans } from "@lingui/macro";
import { Flex } from "@otrium/core";
import styled from "@emotion/styled";
import { Button } from "src/atoms/Button";
import { useTheme } from "@emotion/react";

const StyledPromotionsButton = styled(Button)`
  margin-right: ${({ theme }) => theme.space.space8};
  border: ${({ theme }) => `1px solid ${theme.colors.tone.black}`};
  border-radius: 2px;
  min-width: auto;
  display: block;
  padding-top: ${({ theme }) => theme.space[1]}px;
  padding-bottom: ${({ theme }) => theme.space[1]}px;
  height: auto;
  font-weight: ${({ theme }) => theme.fontWeights.body};
  letter-spacing: normal;
`;

interface Props extends MenuProvided {
  syncStateWithUrl: () => void;
}

const ALL_PROMOTION_FILTER = "All";

const PromotionsFilterSelect: FC<Props> = ({
  items,
  refine,
  syncStateWithUrl,
}) => {
  const theme = useTheme();
  const [activeFilter, setActiveFiltert] = useState(ALL_PROMOTION_FILTER);
  const [syncWithUrlLocal, setSyncWithUrlLocal] = useState(false);

  useEffect(() => {
    const activePromoFilter = items.filter((item) => {
      return item.isRefined;
    });

    if (!activePromoFilter.length) {
      setActiveFiltert(ALL_PROMOTION_FILTER);
    } else {
      const splitlabel = activePromoFilter[0].label.split("||");
      const label = splitlabel[1];
      setActiveFiltert(label);
    }
  }, [items]);

  useEffect(() => {
    if (syncWithUrlLocal) {
      syncStateWithUrl();
      setSyncWithUrlLocal(false);
    }
  }, [syncWithUrlLocal, syncStateWithUrl]);

  if (!items.length) {
    return null;
  }

  return (
    <Flex
      mt={4}
      mb={5}
      overflowX="scroll"
      sx={{
        whiteSpace: "nowrap",
        "::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <StyledPromotionsButton
        key="All"
        css={{
          backgroundColor:
            activeFilter === ALL_PROMOTION_FILTER
              ? theme.colors.tone.black
              : theme.colors.tone.white,
          color:
            activeFilter === ALL_PROMOTION_FILTER
              ? theme.colors.tone.white
              : theme.colors.tone.black,
          "&:hover": {
            backgroundColor:
              activeFilter === ALL_PROMOTION_FILTER
                ? theme.colors.tone.black
                : theme.colors.tone.white,
            color:
              activeFilter === ALL_PROMOTION_FILTER
                ? theme.colors.tone.white
                : theme.colors.tone.black,
          },
        }}
        onClick={() => {
          refine("");
          setActiveFiltert("All");
          setSyncWithUrlLocal(true);
        }}
      >
        <Trans>All</Trans>
      </StyledPromotionsButton>
      {items.map((item) => {
        const splitlabel = item.label.split("||");
        const label = splitlabel[1];
        return (
          <StyledPromotionsButton
            key={label}
            css={{
              backgroundColor:
                activeFilter === label
                  ? theme.colors.tone.black
                  : theme.colors.tone.white,
              color:
                activeFilter === label
                  ? theme.colors.tone.white
                  : theme.colors.tone.black,
              "&:hover": {
                backgroundColor:
                  activeFilter === label
                    ? theme.colors.tone.black
                    : theme.colors.tone.white,
                color:
                  activeFilter === label
                    ? theme.colors.tone.white
                    : theme.colors.tone.black,
              },
            }}
            onClick={() => {
              refine(item.value);
              setSyncWithUrlLocal(true);
              setActiveFiltert(
                item.value !== "" ? label : ALL_PROMOTION_FILTER
              );
            }}
          >
            {label}
          </StyledPromotionsButton>
        );
      })}
    </Flex>
  );
};

const PromotionsFilter = connectMenu(PromotionsFilterSelect);

export default PromotionsFilter;
